import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/",
    name: "PageView",
    component: () => import("@/views/PageView"),
    children: [
      {
        path: "/",
        redirect: "/home",
      },
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/HomePage"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "/about",
        name: "about",
        component: () => import("@/views/about/CompanyAbout"),
        meta: {
          title: "公司简介",
          keepScrollPosition: true
        },
      },
      {
        path: "/solution",
        name: "solution",
        children: [
          {
            path: "elinkht/:activeName?",
            name: "elinkht",
            component: () => import("@/views/solution/Elinkht"),
            meta: {
              title: "大宗一站通平台",
              // keepScrollPosition: true
            },
          },
          {
            path: "digitization/:activeName?",
            name: "digitization",
            component: () => import("@/views/solution/Digitization"),
            meta: {
              title: "数智化解决方案",
              // keepScrollPosition: true
            },
          },
          {
            path: "it-services/:activeName?",
            name: "itServices",
            component: () => import("@/views/solution/ItServices"),
            meta: {
              title: "信息技术服务",
              // keepScrollPosition: true
            },
          },
        ],
      },
      {
        path: "/company",
        name: "company",
        children: [
          {
            path: "dynamic",
            name: "dynamic",
            component: () => import("@/views/company/Dynamic"),
            meta: {
              title: "企业动态",
            },
          },
          {
            path: "news",
            name: "news",
            component: () => import("@/views/company/News"),
            meta: {
              title: "行业新闻",
            },
          },
          {
            path: "/dynamicdetail/:id",
            name: "dynamicdetail",
            component: () => import("@/views/company/DynamicDetail"),
            props: true,
            meta: {
              title: "企业动态",
            },
          }
        ],
      },
    ],
  },
  {
    path: '/:pathMatch(.*)', redirect: '/404',
    redirect: to => {
      // 获取之前的路径
      const previousPath = to.params.pathMatch;
      // 重定向到 404 页面
      return '/404?from=' + previousPath;
    }
  },
  {
    path: '/404',
    name: "404",
    component: () => import("@/views/error/404.vue"),
    meta: {
      title: "404",
    },
  },
];


const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果 savedPosition 存在，则返回 savedPosition 的位置
    if (savedPosition) {
      return savedPosition;
    } else {
      // 如果目标路由需要保留滚动位置，则保持原有的滚动位置
      // if (to.meta.keepScrollPosition) {
      //   console.log("1===========>",to.params.activeName);
      //   console.log("1===========>",to.hash==="");
      //   // if(to.hash==="" && (to.params.activeName==="" || to.params.activeName===undefined)){
      //   //   return { left: 0, top: 0 };
      //   // }
      //   return false;
      // } else {
      // 否则返回顶部位置
      return { left: 0, top: 0 };
      // }
    }
  },
});



//顶部页面加载条
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from "@/store";
NProgress.configure({
  easing: 'ease',
  speed: 500,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.3
})

router.beforeEach((to, from, next) => {
  NProgress.start();
  // if(from.path !== '/404'){
  //   alert(from.fullPath)
  //   store.state.currentPath = from.path
  // }
  updateMeta(to);
  next();
});

router.afterEach(() => {
  NProgress.done()
})

function updateMeta(route) {
  const meta = route.meta;

  // 更新页面标题
  const title = meta.title + "-中资国恒科技官网" || "中资国恒科技官网";
  document.title = title;

  // 更新页面描述
  const description = meta.description || "中资国恒科技官网";
  const descriptionTag = document.querySelector('meta[name="description"]');
  if (descriptionTag) {
    descriptionTag.setAttribute("content", description);
  }
}

export default router;
